import { useTranslator } from '@bluebeam/react-i18n';
import React, { FC } from 'react';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps {
  onAuditCancel: () => void;
  onPublish: () => void;
  disablePublish: boolean;
}
const AuditSubheader: FC<Props> = ({
  onAuditCancel,
  onPublish,
  disablePublish,
  appState,
}) => {
  const { publishRequests } = appState;
  const { translate } = useTranslator(['auditSubheader', 'buttons']);

  return (
    <div
      id="audit-subheader"
      className="hs2 my4 row items-center justify-between"
    >
      <div className="mr4 font-size-7">
        {translate('auditSubheader:readyForReview', {
          count: publishRequests.size,
        })}
      </div>
      <div className="row">
        <div className="mr4">
          <button
            id="audit-subheader-cancel-btn"
            className="btn btn-outline-primary"
            onClick={onAuditCancel}
          >
            {translate('buttons:cancel')}
          </button>
        </div>
        <div>
          <button
            id="audit-page-publish-btn"
            className="btn btn-primary"
            onClick={onPublish}
            disabled={disablePublish}
          >
            {translate('buttons:publish')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default withAppStore<Props>(AuditSubheader);
